import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import { matchType } from 'rangeConfig/shared/filters/selectedMenuProductFilters';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import replaceShelfAndOrganizer from 'rangeConfig/shared/behaviors/replaceShelfAndOrganizer';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseInterior',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: [
    {
      id: 'interior-selected-menu-interior',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      filters: [],
      behaviors: {
        productClicked: [replaceShelfAndOrganizer],
        productDropped: [replaceShelfAndOrganizer]
      },
      productTypes: [
        ProductType.BROR_SHELF_WALL_METAL_BLACK,
        ProductType.BROR_RAIL,
        ProductType.BROR_PEGBOARD_SET
      ],
      productFilters: [matchType]
    }
  ]
};

export default selectedMenu;
